import React from 'react';

import FormFooter, { FooterProps } from './FormFooter';
import { MessageFooterStyles } from './styles';
import { FilesMessageProvider } from '../UploadFileMessage/context';

const Footer = ({
  isUploadFile,
  id,
  isRefreshDocument,
  applicationId,
  centreResponded,
}: FooterProps) => (
  <FilesMessageProvider>
    <MessageFooterStyles>
      <FormFooter
        isUploadFile={isUploadFile}
        id={id}
        applicationId={applicationId}
        isRefreshDocument={isRefreshDocument}
        centreResponded={centreResponded}
      />
    </MessageFooterStyles>
  </FilesMessageProvider>
);

export default Footer;
